import { useCallback } from 'react';

import { useQueryParams } from '@config/react-router-dom/hooks/use-query-params';

export const ACTIVITY_TYPE_TABS_HIDDEN = 'activityTypeTabsHidden';

export const useFeatureFlag = () => {
    const search = useQueryParams();
    const isHiddenFeatureFlag = useCallback((isHidden: boolean) => {
        const activityTypeTabsHidden = search.get(ACTIVITY_TYPE_TABS_HIDDEN);

        if (activityTypeTabsHidden === 'false') return false;

        return isHidden;
    }, [search]);

    return { isHiddenFeatureFlag };
};
